"use client";

import type { MouseEvent } from "react";

import { Link } from "@/components/ui/link/link";
import type { LinkProps } from "@/components/ui/link/link";
import {
  isPlainLeftClick,
  smoothScrollToHash,
} from "@/lib/smooth-scroll-to-hash";

/**
 * Link that smooth-scrolls to an in-page `#hash` target (offset for the fixed
 * header). Non-hash hrefs and modified clicks behave like a normal link.
 */
export function SmoothHashLink({ href, onClick, ...props }: LinkProps) {
  const isHashLink = typeof href === "string" && href.startsWith("#");

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (!isHashLink || event.defaultPrevented || !isPlainLeftClick(event)) {
      return;
    }
    if (smoothScrollToHash(href)) event.preventDefault();
  };

  return <Link href={href} onClick={handleClick} {...props} />;
}
